var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 5.8335L8.97073 10.5964C9.5217 10.982 9.79719 11.1749 10.0968 11.2496C10.3615 11.3156 10.6384 11.3156 10.9031 11.2496C11.2027 11.1749 11.4782 10.982 12.0292 10.5964L18.8333 5.8335M6.16663 16.6668H14.8333C16.2334 16.6668 16.9335 16.6668 17.4683 16.3943C17.9387 16.1547 18.3211 15.7722 18.5608 15.3018C18.8333 14.767 18.8333 14.067 18.8333 12.6668V7.3335C18.8333 5.93336 18.8333 5.2333 18.5608 4.69852C18.3211 4.22811 17.9387 3.84566 17.4683 3.60598C16.9335 3.3335 16.2334 3.3335 14.8333 3.3335H6.16663C4.76649 3.3335 4.06643 3.3335 3.53165 3.60598C3.06124 3.84566 2.67879 4.22811 2.43911 4.69852C2.16663 5.2333 2.16663 5.93336 2.16663 7.3335V12.6668C2.16663 14.067 2.16663 14.767 2.43911 15.3018C2.67879 15.7722 3.06124 16.1547 3.53165 16.3943C4.06643 16.6668 4.76649 16.6668 6.16663 16.6668Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a1833f613a744b78a7ef1a5133223902.svg";
export { ForwardRef as ReactComponent };